<template>
    <div>
        <el-card shadow="never">
            <el-form class="app-form" ref="formRef" :model="form" size="medium" label-width="130px">
                <el-form-item
                :label="$t('select_project_space')"
                prop="space_id"
                :rules="[
                    { required: true, message: $t('project_space_cannot_empty'), trigger: 'blur'},
                ]">
                    <el-select
                    @change="changeSpaceHandler"
                    v-model="form.space_id" 
                    filterable 
                    :placeholder="$t('please_input_keyword')">
                        <el-option
                        v-for="space in spaceList"
                        :key="space.id"
                        :label="space.name"
                        :value="space.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button  icon="el-icon-edit-outline" size="small" type="primary" @click="openDialogHandler">{{$t('workflow_apply') }}</el-button>
                </el-form-item>

            </el-form>
        </el-card>


        <el-dialog
        :width="$root.DialogNormalWidth"
        :title="$t('input_deploy_apply')"
        :visible.sync="dialogVisible"
        @close="closeDialogHandler">
            <div class="app-dialog" v-loading="dialogLoading">
                <el-form class="app-form" ref="dialogRef" :model="dialogForm" size="medium" label-width="130px">
                
                    <el-form-item 
                    :label="$t('name')"
                    prop="name"
                    :rules="[
                        { required: true, message: $t('name_cannot_empty'), trigger: 'blur'},
                    ]">
                        <el-input :placeholder="$t('please_input_name')" v-model="dialogForm.name" autocomplete="off"></el-input>
                    </el-form-item>


                    <el-form-item 
                    :label="$t('illustrate')"
                    prop="description"
                    :rules="[
                        { required: true, message: $t('command_illustrate_cannot_empty'), trigger: 'blur'},
                    ]">
                        <el-input :rows="4" type="textarea" :placeholder="$t('please_input_command_illustrate')" v-model="dialogForm.description" autocomplete="off"></el-input>
                    </el-form-item>

                    
                 </el-form>
                 <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="closeDialogHandler">{{ $t('cancel') }}</el-button>
                    <el-button :loading="btnLoading" size="small" type="primary" @click="dialogSubmitHandler">{{ $t('enter') }}</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    detailSpaceApi,
    listSpaceApi,
} from '@/api/project.js'
import { WorkflowSubmitApi } from '@/api/workflow'

export default {
    data() {
        return {
            form: {
                space_id: undefined,
                template_id: undefined,
                tmode: 1,
            },
            spaceList: [],
            
            dialogVisible: false,
            dialogLoading: false,
            dialogForm: {
                id: 0,
                flow_id: 0,
                status: 2,
            },
            btnLoading: false,
            flowDetail: {},
        }
    },
    methods: {
        dialogSubmitHandler() {
            this.$refs.dialogRef.validate((valid) => {
                if (!valid) {
                    return false;
                }
                this.btnLoading = true
                let postData = {
                    id: this.dialogForm.id,
                    space_id: this.form.space_id,
                    name: this.dialogForm.name,
                    status: this.dialogForm.status,
                    description: this.dialogForm.description,
                }
                WorkflowSubmitApi(postData).then(res => {
                    this.$alert( this.$t('submit_success'), {
                        type: 'success',
                        confirmButtonText: this.$t('enter'),
                        callback: action => {
                            this.closeDialogHandler()
                            this.$router.push({name: 'workFlow'})
                        }
                    })
                    this.btnLoading = false
                }).catch(err => {
                    this.btnLoading = false
                })
            })
        },
        openDialogHandler() {
            this.$refs.formRef.validate((valid) => {
                if (!valid) {
                    return false;
                }
                this.dialogVisible = true
            })
        },
        closeDialogHandler() {
            this.dialogVisible = false
        },
        changeSpaceHandler(spaceId) {
            this.form.template_id = undefined
        },

        loadSpaceList() {
            listSpaceApi({offset: 0, limit : 999}).then(res => {
                if (res.list) {
                    this.spaceList = res.list
                }
            })
        },
        
        
    },
    mounted() {
        this.loadSpaceList()
    },
}
</script>
